import React from 'react';

const DatasetConditionDescription = ({ datasetCondition, children }) => (
  <div className="flex flex-wrap gap-5 items-baseline p-8">
    {datasetCondition.condition.description}
    {children}
  </div>
);

export default DatasetConditionDescription;
